import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["template", "minBlockSize"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardSmartProperty } from './CardSmartProperty';
import { useSmartPropertyTemplates } from './SmartPropertyTemplatesProvider/SmartPropertyTemplatesProvider';
import { LabelFieldType } from './LabelFieldType';
import { LabelDataSource } from './LabelDataSource';
import { LayoutHorizontal } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export const SmartPropertyTemplateCard = _ref => {
  let {
      template,
      minBlockSize = '7rem'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onCreateTemplate,
    isLoading
  } = useSmartPropertyTemplates();
  const {
    dataSource,
    fieldType,
    propertyLabel,
    enrichmentQuestion
  } = template !== null && template !== void 0 ? template : {};
  const handleUseTemplate = () => {
    onCreateTemplate(template);
    /**
     * @todo Add back tracking
     */
    // track('Smart Property Form Opened', {
    //   template: true,
    //   templateId: propertyLabel,
    // });
  };
  return /*#__PURE__*/_createElement(CardSmartProperty, Object.assign({}, rest, {
    "data-test-id": "smart-property-card",
    isLoading: isLoading,
    key: propertyLabel,
    minBlockSize: minBlockSize
  }), /*#__PURE__*/_jsxs(CardSmartProperty.Header, {
    children: [/*#__PURE__*/_jsxs(CardSmartProperty.Heading, {
      children: [/*#__PURE__*/_jsx("span", {
        children: propertyLabel
      }), /*#__PURE__*/_jsxs(LayoutHorizontal, {
        gap: "space-sm",
        children: [/*#__PURE__*/_jsx(LabelFieldType, {
          fieldType: fieldType
        }), /*#__PURE__*/_jsx(LabelDataSource, {
          dataSource: dataSource
        })]
      })]
    }), /*#__PURE__*/_jsx(CardSmartProperty.Button, {
      onClick: handleUseTemplate,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyTemplates.card.cta"
      })
    })]
  }), /*#__PURE__*/_jsx(CardSmartProperty.Body, {
    children: /*#__PURE__*/_jsx(CardSmartProperty.Description, {
      children: enrichmentQuestion
    })
  }));
};